// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__gsovM","label":"Category_label__2yzFv","content":"Category_content__2Xhkb","header":"Category_header__27CYn","location":"Category_location__XoELU"};